import { render, staticRenderFns } from "./ImportetToYou.vue?vue&type=template&id=4e940be2&scoped=true"
import script from "./ImportetToYou.vue?vue&type=script&lang=js"
export * from "./ImportetToYou.vue?vue&type=script&lang=js"
import style0 from "./ImportetToYou.vue?vue&type=style&index=0&id=4e940be2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e940be2",
  null
  
)

export default component.exports